import { createApi } from '../axios'
import { baseURL } from '../config'

function responseHandle (res) {
  let msg = ''
  if (!res.data) {
    msg = res.status
    throw new Error(msg)
  } else if (res.data.ret !== 0) {
    msg = res.data.ret + ' ' + res.data.msg
    throw new Error(msg)
  }

  return res.data
} 

export default createApi(responseHandle, {
  getVipFlow (params) {
    return {
      // url: 'http://9.218.41.171:11026/api/v1/hlwmp/get_vipflow',
      url: '/api/v1/hlwmp/get_vipflow',
      method: 'get',
      params: params,
      baseURL: baseURL
    }
  },
  getVipBind (params) {
    return {
      url: '/api/v1/hlwmp/get_vipbind',
      method: 'post',
      data: params,
      baseURL: baseURL
    }
  },
})
